function generateKey(context, customKey, property, options) {
  let prefix = options?.prefix ?? context.constructor.name;
  let key = [prefix, property];

  if (customKey) {
    let customKeyValue = context;

    for (let segement of customKey.split('.')) {
      if (customKeyValue) {
        customKeyValue = customKeyValue[segement];
      }
    }

    // If we find an property on the context we use the value, otherwise we use the customKey (string) as key
    key.push(customKeyValue ?? customKey);
  }

  return key.join('-');
}

export default function storeOnRoute(customKey, options) {
  return function (target, property) {
    return {
      set: function (value) {
        const key = generateKey(this, customKey, property, options);

        this.breadcrumb.currentRoute?.routeData.set(key, value);
      },
      get: function () {
        const key = generateKey(this, customKey, property, options);

        return this.breadcrumb.currentRoute?.routeData.get(key);
      },
      enumerable: true,
      configurable: true,
    };
  };
}
